/**
 * Shared demo flow used by both /demo (playbook) and /plate (sales page).
 * Each entry maps to a real route already wired in App.js.
 */
import {
  Eye, Calculator, Layers, Sparkles,
  TrendingUp, FileText, Store, Coffee, ClipboardList,
} from "lucide-react";

export const DEMOS = [
  {
    n: 1, icon: TrendingUp,
    type: "Pitch · Video + Read", duration: "10 min",
    title: "Investor Pitch — The Big Picture",
    why: "Set the stage. TAM, traction, business model, 5-year vision. Watch the 4-min video, then scroll the deck.",
    to: "/pitch/investor",
  },
  {
    n: 2, icon: Eye,
    type: "Pitch · Consumer-side", duration: "6 min",
    title: "Diner Pitch — Why Australians Will Use It",
    why: "Demand side. Local discovery, savings, loyalty. Same pitch you'd run for everyday consumers.",
    to: "/pitch/diner",
  },
  {
    n: 3, icon: Coffee,
    type: "Pitch · Supply-side", duration: "8 min",
    title: "Owner Pitch — Why Cafés Will Sign Up",
    why: "Supply side. 20–50% bulk savings, automated marketing, claim-and-onboard flow.",
    to: "/pitch/owner",
  },
  {
    n: 4, icon: Calculator,
    type: "Live demo", duration: "5 min",
    title: "Restaurant Savings Calculator",
    why: "The hero ROI moment. Punch in real numbers, hit Calculate, watch the saved-per-year number.",
    to: "/sales",
  },
  {
    n: 5, icon: ClipboardList,
    type: "Pricing proposal", duration: "4 min",
    title: "HustlePlate Tiers — Proposal Sheet",
    why: "Print-ready proposal sheet for restaurants. Free / Starter / Pro / Enterprise tiers with feature list + competition price comparison.",
    to: "/plate",
  },
  {
    n: 6, icon: Sparkles,
    type: "Pitch · Vertical expansion", duration: "5 min",
    title: "Salon Pitch — Multi-Vertical Proof",
    why: "Quick vertical-expansion proof. Same playbook, second industry. Builds the case this isn't just hospitality.",
    to: "/pitch/salon",
  },
  {
    n: 7, icon: Layers,
    type: "Live directory", duration: "5 min",
    title: "Australian Directory — 25k Live Entities",
    why: "Open the real directory at scale. Pins on Brisbane / GC / Sunshine Coast. Click into any venue.",
    to: "/directory/au",
  },
  {
    n: 8, icon: Store,
    type: "E-commerce template", duration: "5 min",
    title: "HustlePlaza — Cooperative-Buying Marketplace",
    why: "Marketplace upside. Browse 19-group taxonomy, click a product, run fuzzy search. End on waitlist CTA.",
    to: "/plaza", featured: true,
  },
  {
    n: 9, icon: Coffee,
    type: "Vendor skin example", duration: "3 min",
    title: "Coffee Commune — Tenant Template",
    why: "Multi-tenant story. Same engine, custom skin per vendor. \"This is what each founding vendor gets.\"",
    to: "/coffee-commune",
  },
  {
    n: 10, icon: FileText,
    type: "Take-home assets", duration: "1 min",
    title: "Materials — Download the Decks",
    why: "Each pitch page has PDF + PPT buttons. Tracked in HustleCRM so we know who opened what after the meeting.",
    to: "/pitch/investor",
    note: "Scroll to the bottom of any pitch page for PDF + PPT buttons.",
  },
];
